import React, { lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import SplashCursor from "./components/SplashCursor";
import { Toaster } from "./components/ui/sonner";
import ChatWidget from "./components/ChatWidget";

// Rutas críticas (above-the-fold) — carga inmediata
const Home = lazy(() =>
  import("./pages/Home").then((m) => ({ default: m.Home })),
);
const About = lazy(() =>
  import("./pages/About").then((m) => ({ default: m.About })),
);
const Contact = lazy(() =>
  import("./pages/Contact").then((m) => ({ default: m.Contact })),
);
const NotFound = lazy(() =>
  import("./pages/NotFound").then((m) => ({ default: m.NotFound })),
);

// Rutas secundarias — lazy load
const Services = lazy(() =>
  import("./pages/Services").then((m) => ({ default: m.Services })),
);
const CreativeLab = lazy(() =>
  import("./pages/CreativeLab").then((m) => ({ default: m.CreativeLab })),
);
const IntelligenceLab = lazy(() =>
  import("./pages/IntelligenceLab").then((m) => ({
    default: m.IntelligenceLab,
  })),
);
const Portfolio = lazy(() =>
  import("./pages/Portfolio").then((m) => ({ default: m.Portfolio })),
);
const PortfolioItem = lazy(() =>
  import("./pages/PortfolioItem").then((m) => ({ default: m.PortfolioItem })),
);
const Pricing = lazy(() =>
  import("./pages/Pricing").then((m) => ({ default: m.Pricing })),
);
const Methodology = lazy(() =>
  import("./pages/Methodology").then((m) => ({ default: m.Methodology })),
);
const Blog = lazy(() =>
  import("./pages/Blog").then((m) => ({ default: m.Blog })),
);
const BlogPost = lazy(() =>
  import("./pages/BlogPost").then((m) => ({ default: m.BlogPost })),
);

// Creative Lab Services
const BrandingNaming = lazy(() =>
  import("./pages/creative-lab/BrandingNaming").then((m) => ({
    default: m.BrandingNaming,
  })),
);
const SocialMediaAds = lazy(() =>
  import("./pages/creative-lab/SocialMediaAds").then((m) => ({
    default: m.SocialMediaAds,
  })),
);
const CreativeCampaigns = lazy(() =>
  import("./pages/creative-lab/CreativeCampaigns").then((m) => ({
    default: m.CreativeCampaigns,
  })),
);
const WebExperiences = lazy(() =>
  import("./pages/creative-lab/WebExperiences").then((m) => ({
    default: m.WebExperiences,
  })),
);

// Intelligence Lab Services
const ChatbotsAssistants = lazy(() =>
  import("./pages/intelligence-lab/ChatbotsAssistants").then((m) => ({
    default: m.ChatbotsAssistants,
  })),
);
const LeadAutomation = lazy(() =>
  import("./pages/intelligence-lab/LeadAutomation").then((m) => ({
    default: m.LeadAutomation,
  })),
);
const HROptimization = lazy(() =>
  import("./pages/intelligence-lab/HROptimization").then((m) => ({
    default: m.HROptimization,
  })),
);
const AIConsulting = lazy(() =>
  import("./pages/intelligence-lab/AIConsulting").then((m) => ({
    default: m.AIConsulting,
  })),
);

function App() {
  return (
    <div className="App bg-background-light dark:bg-background-dark text-text-light dark:text-text-dark font-body antialiased transition-colors duration-300 relative">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Suspense fallback={<div className="min-h-screen" />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/creative-lab" element={<CreativeLab />} />
            <Route path="/intelligence-lab" element={<IntelligenceLab />} />

            {/* Creative Labs Services */}
            <Route
              path="/creative-lab/branding-naming"
              element={<BrandingNaming />}
            />
            <Route
              path="/creative-lab/social-media-ads"
              element={<SocialMediaAds />}
            />
            <Route
              path="/creative-lab/creative-campaigns"
              element={<CreativeCampaigns />}
            />
            <Route
              path="/creative-lab/web-experiences"
              element={<WebExperiences />}
            />

            {/* Intelligence Labs Services */}
            <Route
              path="/intelligence-lab/chatbots-assistants"
              element={<ChatbotsAssistants />}
            />
            <Route
              path="/intelligence-lab/lead-automation"
              element={<LeadAutomation />}
            />
            <Route
              path="/intelligence-lab/hr-optimization"
              element={<HROptimization />}
            />
            <Route
              path="/intelligence-lab/ai-consulting"
              element={<AIConsulting />}
            />

            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/portfolio/:slug" element={<PortfolioItem />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/methodology" element={<Methodology />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />

            {/* 404 - Catch all */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <Footer />
        <Toaster />
        <ChatWidget />
      </BrowserRouter>
      <SplashCursor />
    </div>
  );
}

export default App;
